(function () {
  const selector = '[data-category-icon-grid]';
  const instances = new Map();

  class CategoryIconGrid {
    constructor(element) {
      this.element = element;
      this.scrollContainer = this.element.querySelector('[data-category-icon-grid-scroll]');

      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;

      this.handleMouseDown = this.handleMouseDown.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleMouseUp = this.handleMouseUp.bind(this);
      this.handleMouseMove = this.handleMouseMove.bind(this);

      if (this.scrollContainer && window.innerWidth >= 750) {
        this.enableMouseDrag();
      }
    }

    enableMouseDrag() {
      this.scrollContainer.addEventListener('mousedown', this.handleMouseDown);
      this.scrollContainer.addEventListener('mouseleave', this.handleMouseLeave);
      this.scrollContainer.addEventListener('mouseup', this.handleMouseUp);
      this.scrollContainer.addEventListener('mousemove', this.handleMouseMove);
      this.scrollContainer.style.cursor = 'grab';
    }

    handleMouseDown(event) {
      this.isDown = true;
      this.scrollContainer.style.cursor = 'grabbing';
      this.startX = event.pageX - this.scrollContainer.offsetLeft;
      this.scrollLeft = this.scrollContainer.scrollLeft;
    }

    handleMouseLeave() {
      this.isDown = false;
      this.scrollContainer.style.cursor = 'grab';
    }

    handleMouseUp() {
      this.isDown = false;
      this.scrollContainer.style.cursor = 'grab';
    }

    handleMouseMove(event) {
      if (!this.isDown) return;

      event.preventDefault();
      const x = event.pageX - this.scrollContainer.offsetLeft;
      const walk = (x - this.startX) * 2;
      this.scrollContainer.scrollLeft = this.scrollLeft - walk;
    }

    disconnect() {
      if (!this.scrollContainer) return;

      this.scrollContainer.removeEventListener('mousedown', this.handleMouseDown);
      this.scrollContainer.removeEventListener('mouseleave', this.handleMouseLeave);
      this.scrollContainer.removeEventListener('mouseup', this.handleMouseUp);
      this.scrollContainer.removeEventListener('mousemove', this.handleMouseMove);
    }
  }

  function getTargets(root) {
    const targets = [];

    if (root instanceof Element && root.matches(selector)) {
      targets.push(root);
    }

    if (root.querySelectorAll) {
      targets.push(...root.querySelectorAll(selector));
    }

    return targets;
  }

  function init(root) {
    getTargets(root).forEach((element) => {
      if (instances.has(element)) return;
      instances.set(element, new CategoryIconGrid(element));
    });
  }

  function destroy(root) {
    getTargets(root).forEach((element) => {
      const instance = instances.get(element);
      if (!instance) return;

      instance.disconnect();
      instances.delete(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroy(event.target);
  });
})();
